import * as React from "react";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";

const AspectRatio = ({
  children,
  ratio,
  wrapperClassName,
  contentClassName,
}) => {
  return (
    <div className={getClasses(styles["wrapper"], wrapperClassName)}>
      <div style={{ paddingBottom: `${(1 / ratio) * 100}%` }}></div>
      <div className={getClasses(styles["content"], contentClassName)}>
        {children}
      </div>
    </div>
  );
};

export default AspectRatio;
